import React, { useState, useEffect, useContext } from "react";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import { concludePurchaseOperationData } from "../../../apis/apis.logistics/apisProduct";
import Swal from "sweetalert2";

  
export function ConcludeOrderPurchaseList({
    order,
    setOrder,
    initialOrderState,
  }) {
    const concludePurchaseOperation = async (id) => {
        try {
          const response = await concludePurchaseOperationData({operationID: id});
          return response;
        } catch (error) {
          throw error;
        }
      };
    const navigate = useNavigate();
    
    const handleConclude = async () => {
      Swal.fire({
        title: "¿Está usted seguro?",
        text: "¿Concluir esta orden de compra?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc2626",
        cancelButtonColor: "#6b7280",
        confirmButtonText: "Sí, concluir",
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (result.isConfirmed) {
          concludePurchaseOperation(order.operationID)
            .then((r) => {
              if (r.status == 201) {
                toast.success("Orden concluida con éxito!");
                navigate("/buys/purchase_orders_issued");
              } else {
                toast.error("Ocurrió algún error");
              }
            });
        }
      });
    };

    return (
      <>
        <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm overflow-hidden mb-6">
          
          {/* Desktop View - Table */}
          <div className="hidden md:block overflow-x-auto">
            <table className="w-full text-sm text-left">
              <thead className="bg-gray-900 text-gray-100">
                <tr>
                  <th className="px-4 py-3 font-semibold text-xs uppercase tracking-wider">PRODUCTO</th>
                  <th className="px-4 py-3 font-semibold text-xs uppercase tracking-wider">UNIDAD</th>
                  <th className="px-4 py-3 font-semibold text-xs uppercase tracking-wider text-center">CANTIDAD ORDENADA</th>
                  <th className="px-4 py-3 font-semibold text-xs uppercase tracking-wider text-center">CANTIDAD FALTANTE</th>
                  <th className="px-4 py-3 font-semibold text-xs uppercase tracking-wider text-center">CANTIDAD RECIBIDA</th>
                  <th className="px-4 py-3 font-semibold text-xs uppercase tracking-wider text-center">FEC. VTO</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 dark:divide-gray-700">
                {order.operationItems.map((item, index) => {
                  const missingQuantity = Number(item.quantityOrdered) - Number(item.quantityReceived) - Number(item.quantity);
                  return (
                    <tr key={index} className="hover:bg-gray-50 dark:hover:bg-gray-700/50 transition-colors">
                      <td className="px-4 py-3 text-gray-900 dark:text-white">{item.productName}</td>
                      <td className="px-4 py-3 text-gray-600 dark:text-gray-400">{item.unitName}</td>
                      <td className="px-4 py-3 text-gray-900 dark:text-white text-center">{item.quantityOrdered}</td>
                      <td className="px-4 py-3 text-center">
                        <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${missingQuantity > 0 ? 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400' : 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400'}`}>
                          {missingQuantity}
                        </span>
                      </td>
                      <td className="px-4 py-3 text-gray-900 dark:text-white text-center">{Number(item.quantityReceived)}</td>
                      <td className="px-4 py-3 text-gray-600 dark:text-gray-400 text-center">{item.expireDate}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {/* Mobile View - Cards */}
          <div className="md:hidden">
            {order.operationItems.map((item, index) => {
              const missingQuantity = Number(item.quantityOrdered) - Number(item.quantityReceived) - Number(item.quantity);
              return (
                <div key={index} className="p-4 border-b border-gray-200 dark:border-gray-700 last:border-b-0">
                  <div className="flex justify-between items-start mb-3">
                    <div>
                      <h4 className="font-semibold text-gray-900 dark:text-white">{item.productName}</h4>
                      <p className="text-sm text-gray-600 dark:text-gray-400">{item.unitName}</p>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-3 text-sm">
                    <div>
                      <p className="text-gray-500 dark:text-gray-400 text-xs uppercase">Cantidad Ordenada</p>
                      <p className="font-medium text-gray-900 dark:text-white">{item.quantityOrdered}</p>
                    </div>
                    <div>
                      <p className="text-gray-500 dark:text-gray-400 text-xs uppercase">Cantidad Faltante</p>
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${missingQuantity > 0 ? 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400' : 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400'}`}>
                        {missingQuantity}
                      </span>
                    </div>
                    <div>
                      <p className="text-gray-500 dark:text-gray-400 text-xs uppercase">Cantidad Recibida</p>
                      <p className="font-medium text-gray-900 dark:text-white">{Number(item.quantityReceived)}</p>
                    </div>
                    <div>
                      <p className="text-gray-500 dark:text-gray-400 text-xs uppercase">Fecha Vto</p>
                      <p className="font-medium text-gray-900 dark:text-white">{item.expireDate}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 justify-between items-start sm:items-center">
          <div className="flex flex-wrap gap-3">
            <Link 
              to='/buys/new_purchase_order' 
              className="inline-flex items-center gap-2 px-4 py-2 border border-gray-300 dark:border-gray-600 text-sm font-medium rounded-lg text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors"
            >
              <i className="fas fa-plus"></i>
              Nuevo
            </Link>
            <Link 
              to='/buys/purchase_orders_issued' 
              className="inline-flex items-center gap-2 px-4 py-2 border border-gray-300 dark:border-gray-600 text-sm font-medium rounded-lg text-gray-700 dark:text-gray-300 bg-white dark:bg-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors"
            >
              <i className="fas fa-list"></i>
              Orden de Compras
            </Link>
          </div>
          <button
            type="button"
            className="inline-flex items-center gap-2 px-4 py-2 border border-transparent text-sm font-medium rounded-lg text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors"
            onClick={handleConclude}
          >
            Concluir orden compra
          </button>
        </div>
      </>
    );
}
